import React from "react";
import img1 from "../assests/home-office-space01.jpg";
import img2 from "../assests/home-office-space02.jpg";
import img3 from "../assests/home-office-space03.jpg";
import img4 from "../assests/home-office-space04.jpg";
import img5 from "../assests/home-office-space05.jpg";

const OurOffice = () => {
  return (
    <>
      <section id="office-space" className="startup-team ">
        <div className="container-fluid">
          <div class="row">
            <div className="col-12 text-center">
              <h1 className="text-white">
                Premium & Affordable Office Space For Rent
              </h1>
              <p
                className="h2 text-white"
                style={{ fontSize: "25px", marginTop: "15px" }}
              >
                Boost Your Business with Premium Dedicated and Co working Spaces
                at Premisin
              </p>
              <p
                className="text-white"
                style={{ fontSize: "20px", marginTop: "15px" }}
              >
                Our offices are designed to inspire and motivate, offering an
                affordable solution for businesses of all sizes.
              </p>
              <div class="u-h-4 u-w-50 bg-white rounded mt-4 u-mb-50 mx-auto"></div>
            </div>
          </div>

          <div className="col-1 d-none d-lg-block"></div>

          <div className="row">
            <div className="col-12 d-flex flex-column flex-lg-row">
              <div className="card mx-2 overflow-hidden mb-4">
                {/* <div className="card"> */}
                <div className="u-pos-rel">
                  <img
                    className="lazyloadimg w-100"
                    src={img1}
                    data-original="assets/img/home-office-space01.jpg"
                    alt="Premisin"
                  />
                </div>
                <div className="p-4">
                  <h4 className="mb-0">Cabin</h4>
                  <h6 className="text-blue">
                    Starting @ <i className="fa fa-rupee"></i> 12500 /month
                  </h6>
                  <ul className="list-unstyled u-fs-16 u-fw-500 u-ff-dosis mb-0 u-lh-2">
                    <li>
                      <i className="fa fa-check mr-2"></i> Modern furniture
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> High speed internet
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Electricity
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Hassle free setup
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Daily cleaning and
                      sanitisation
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Safe and secure
                      workspaces
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> No hidden cost
                    </li>
                  </ul>
                  <div className="text-center d-lg-none">
                    <button
                      className="btn btn btn-rounded btn-white mt-5 text-primary"
                      onClick={() => window.gtag("event", "ouroffice_button_click_enuire_now_cabin")}
                      data-toggle="modal"
                      data-target="#sidenavmail"
                    >
                      Enquire Now
                    </button>
                  </div>
                </div>
              </div>
              <div class="card mx-2 overflow-hidden mb-4">
                <div className="u-pos-rel">
                  <img
                    className="lazyloadimg w-100"
                    src={img2}
                    data-original="assets/img/home-office-space02.jpg?a=b"
                    alt="Premisin"
                  />
                </div>
                <div className="p-4">
                  <h4 className="mb-0">Fixed Desk</h4>
                  <h6 className="text-blue">
                    Starting @ <i className="fa fa-rupee"></i> 4500 /month
                  </h6>
                  <ul className="list-unstyled u-fs-16 u-fw-500 u-ff-dosis mb-0 u-lh-2">
                    <li>
                      <i className="fa fa-check mr-2"></i> Modern furniture
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> High speed internet
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Electricity
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Hassle free setup
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Daily cleaning and
                      sanitisation
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Safe and secure
                      workspaces
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> No hidden cost
                    </li>
                  </ul>
                  <div className="text-center d-lg-none">
                    <button
                      className="btn btn btn-rounded btn-white mt-5 text-primary"
                      onClick={() => window.gtag("event", "ouroffice_button_click_enuire_now_fixed_desk")}
                      data-toggle="modal"
                      data-target="#sidenavmail"
                    >
                      Enquire Now
                    </button>
                  </div>
                </div>
              </div>
              <div class="card mx-2 overflow-hidden mb-4">
                <div className="u-pos-rel">
                  <img
                    className="lazyloadimg w-100"
                    src={img3}
                    data-original="assets/img/home-office-space03.jpg"
                    alt="Premisin"
                  />
                </div>
                <div className="p-4">
                  <h4 className="mb-0">Meeting Rooms</h4>
                  <h6 className="text-blue">
                    Starting @ <i className="fa fa-rupee"></i> 500 /hour
                  </h6>
                  <ul className="list-unstyled u-fs-16 u-fw-500 u-ff-dosis mb-0 u-lh-2">
                    <li>
                      <i className="fa fa-check mr-2"></i> Italian Finish Desk
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Premium Chairs and
                      Drawers
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> High speed internet
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Power Back up
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Projector
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> White board
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Lift
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Reserved Parking
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Visitor Parking
                    </li>
                  </ul>
                  <div className="text-center d-lg-none">
                    <button
                      className="btn btn btn-rounded btn-white mt-5 text-primary"
                      onClick={() => window.gtag("event", "ouroffice_button_click_enuire_now_meeting_rooms")}
                      data-toggle="modal"
                      data-target="#sidenavmail"
                    >
                      Enquire Now
                    </button>
                  </div>
                </div>
              </div>
              <div class="card mx-2 overflow-hidden mb-4">
                <div className="u-pos-rel">
                  <img
                    className="lazyloadimg w-100"
                    src={img4}
                    data-original="assets/img/home-office-space04.jpg"
                    alt="Premisin"
                  />
                </div>
                <div className="p-4">
                  <h4 className="mb-0">Private Office</h4>
                  <h6 className="text-blue">
                    Starting @ <i className="fa fa-rupee"></i> 50000 /month
                  </h6>
                  <ul className="list-unstyled u-fs-16 u-fw-500 u-ff-dosis mb-0 u-lh-2">
                    <li>
                      <i className="fa fa-check mr-2"></i> Italian Finish Desk
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Premium Chairs and
                      Drawers
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Lift
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Recreational Zone
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Pedestals / Storage
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Power Back up
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Reserved Parking
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Visitor Parking
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Security
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Washrooms
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Pantry
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Recreational Zone
                    </li>
                  </ul>
                  <div className="text-center d-lg-none">
                    <button
                      className="btn btn btn-rounded btn-white mt-5 text-primary"
                      onClick={() => window.gtag("event", "ouroffice_button_click_enuire_now_private_office")}
                      data-toggle="modal"
                      data-target="#sidenavmail"
                    >
                      Enquire Now
                    </button>
                  </div>
                </div>
              </div>
              <div class="card mx-2 overflow-hidden mb-4">
                <div className="u-pos-rel">
                  <img
                    className="lazyloadimg w-100"
                    src={img5}
                    data-original="assets/img/home-office-space05.jpg"
                    alt="Premisin"
                  />
                </div>
                <div className="p-4">
                  <h4 className="mb-0">Virtual Office</h4>
                  <h6 className="text-blue">
                    Starting @ <i className="fa fa-rupee"></i> 1750 /month
                  </h6>
                  <ul className="list-unstyled u-fs-16 u-fw-500 u-ff-dosis mb-0 u-lh-2">
                    <li>
                      <i className="fa fa-check mr-2"></i> GST Registration
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Business Registration
                    </li>
                    <li>
                      <i className="fa fa-check mr-2"></i> Mailing Address
                    </li>
                  </ul>
                  <div className="text-center d-lg-none">
                    <button
                      className="btn btn btn-rounded btn-white mt-5 text-primary"
                      onClick={() => window.gtag("event", "ouroffice_button_click_enuire_now_virtual_office")}
                      data-toggle="modal"
                      data-target="#sidenavmail"
                    >
                      Enquire Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center d-none d-lg-block">
          <button
            className="btn btn btn-rounded btn-white mt-5 text-primary "
            onClick={() => window.gtag("event", "ouroffice_button_click_enuire_now")}
            data-toggle="modal"
            data-target="#sidenavmail"
          >
            Enquire Now
          </button>
        </div>
      </section>
    </>
  );
};

export default OurOffice;
